import { createContext, useContext } from 'react';

export const ShadowRootContext = createContext(null);

export function useShadowRoot() {
  return useContext(ShadowRootContext);
}